var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 23.75V21.3333C1.25 20.0515 1.75922 18.8221 2.66565 17.9157C3.57208 17.0092 4.80145 16.5 6.08333 16.5H10.9167C12.1985 16.5 13.4279 17.0092 14.3343 17.9157C15.2408 18.8221 15.75 20.0515 15.75 21.3333V23.75M3.66667 6.83333C3.66667 8.11521 4.17589 9.34459 5.08232 10.251C5.98874 11.1574 7.21812 11.6667 8.5 11.6667C9.78188 11.6667 11.0113 11.1574 11.9177 10.251C12.8241 9.34459 13.3333 8.11521 13.3333 6.83333C13.3333 5.55145 12.8241 4.32208 11.9177 3.41565C11.0113 2.50922 9.78188 2 8.5 2C7.21812 2 5.98874 2.50922 5.08232 3.41565C4.17589 4.32208 3.66667 5.55145 3.66667 6.83333Z",
    stroke: "#F15A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOrange);
export default __webpack_public_path__ + "static/media/user-orange.d7283e921ec23fc756d758c90727f2ea.svg";
export { ForwardRef as ReactComponent };